module.exports = __webpack_public_path__ + "static/18-2-2fc3c9c0fffd5ebb5e4bff79c7282c50.jpg";